;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import type React from 'react';

interface CollapseIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export function CollapseIcon({ size = 24, ...props }: CollapseIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Collapse">
        <path
          id="Vector (Stroke)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.14645 2.14645C2.34171 1.95118 2.65829 1.95118 2.85355 2.14645L5.5 4.79289V3C5.5 2.72386 5.72386 2.5 6 2.5C6.27614 2.5 6.5 2.72386 6.5 3V6C6.5 6.27614 6.27614 6.5 6 6.5H3C2.72386 6.5 2.5 6.27614 2.5 6C2.5 5.72386 2.72386 5.5 3 5.5H4.79289L2.14645 2.85355C1.95118 2.65829 1.95118 2.34171 2.14645 2.14645ZM13.1464 2.14645C13.3417 1.95118 13.6583 1.95118 13.8536 2.14645C14.0488 2.34171 14.0488 2.65829 13.8536 2.85355L11.2071 5.5H13C13.2761 5.5 13.5 5.72386 13.5 6C13.5 6.27614 13.2761 6.5 13 6.5H10C9.72386 6.5 9.5 6.27614 9.5 6V3C9.5 2.72386 9.72386 2.5 10 2.5C10.2761 2.5 10.5 2.72386 10.5 3V4.79289L13.1464 2.14645ZM3 10.5C2.72386 10.5 2.5 10.2761 2.5 10C2.5 9.72386 2.72386 9.5 3 9.5H6C6.27614 9.5 6.5 9.72386 6.5 10V13C6.5 13.2761 6.27614 13.5 6 13.5C5.72386 13.5 5.5 13.2761 5.5 13V11.2071L2.85355 13.8536C2.65829 14.0488 2.34171 14.0488 2.14645 13.8536C1.95118 13.6583 1.95118 13.3417 2.14645 13.1464L4.79289 10.5H3ZM9.5 10C9.5 9.72386 9.72386 9.5 10 9.5H13C13.2761 9.5 13.5 9.72386 13.5 10C13.5 10.2761 13.2761 10.5 13 10.5H11.2071L13.8536 13.1464C14.0488 13.3417 14.0488 13.6583 13.8536 13.8536C13.6583 14.0488 13.3417 14.0488 13.1464 13.8536L10.5 11.2071V13C10.5 13.2761 10.2761 13.5 10 13.5C9.72386 13.5 9.5 13.2761 9.5 13V10Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
